import { createMuiTheme } from '@material-ui/core/styles'
import { blue, grey, red } from '@material-ui/core/colors'
import responsiveFontSizes from '@material-ui/core/styles/responsiveFontSizes'

const theme = (prefersDarkMode = false) =>
    responsiveFontSizes(
        createMuiTheme({ ...(prefersDarkMode ? dark : light), ...common })
    )

const common = {
    typography: {
        h1: {
            fontSize: '2rem'
        },
        h2: {
            fontSize: '1.75rem'
        },
        h3: {
            fontSize: '1.2rem'
        },
        h4: {
            fontSize: '1.25rem'
        },
        h5: {
            fontSize: '1.175rem'
        },
        h6: {
            fontSize: '1.1rem'
        },
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            'sans-serif'
        ].join(',')
    }
}

const light = {
    palette: {
        type: 'light',
        primary: {
            light: blue['400'],
            main: blue['700'],
            dark: blue['900']
        },
        secondary: {
            light: red['200'],
            main: red['400'],
            dark: red['600']
        },
        error: {
            light: red['500'],
            main: red['500'],
            dark: red['500']
        },
        background: {
            accent: grey['200']
        }
    },
    status: {
        danger: 'orange'
    }
}

const dark = {
    palette: {
        type: 'dark',
        primary: {
            light: blue['300'],
            main: blue['500'],
            dark: blue['700']
        },
        secondary: {
            light: red['200'],
            main: red['400'],
            dark: red['600']
        },
        error: {
            light: red['500'],
            main: red['500'],
            dark: red['500']
        },
        background: {
            accent: '#383838'
        }
    },
    status: {
        danger: 'orange'
    }
}

export default theme
